module.exports = __webpack_public_path__ + "img/azure_oidc.0f50ca62.png";